import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { FuelPrice } from '../types/fuel-price.type';
import { FuelPriceStateModel, UpdateFormFuelPrice } from './fuel-price.action';

@State<FuelPriceStateModel>({
  name: 'fuelPrice',
  defaults: {
    formValue: {},
    formValid: false,
    isLoading: true
  }
})
@Injectable()
export class FuelPriceState {
  @Selector()
  static isLoading(state: FuelPriceStateModel): boolean {
    return state.isLoading;
  }

  @Selector()
  static getFormValue(state: FuelPriceStateModel): FuelPrice {
    return state.formValue;
  }

  @Selector()
  static isValid(state: FuelPriceStateModel): boolean {
    return state.formValid;
  }

  @Action(UpdateFormFuelPrice)
  updateFormObjectives({ patchState }: StateContext<FuelPriceStateModel>, { payload }: UpdateFormFuelPrice): void {
    patchState({
      formValue: payload.value,
      formValid: payload.valid,
      isLoading: false
    });
  }
}
